import React from 'react';
import { FiCheck, FiShield } from 'react-icons/fi';

const Authenticity = () => {
  return (
    <section id="authenticity" className="py-16 bg-background-dark">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">Our Authenticity Guarantee</h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Every item sold on our platform undergoes a rigorous authentication process
            to ensure you only receive 100% authentic products.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-background-light p-6 rounded-lg shadow-md border border-gray-800">
            <div className="flex items-center justify-center h-16 w-16 rounded-full bg-accent text-white mb-4 mx-auto">
              <FiShield className="h-8 w-8" />
            </div>
            <h3 className="text-xl font-semibold text-center mb-3 text-white">Verification</h3>
            <p className="text-gray-400 text-center">
            In addition to our manual authentication, we leverage multipleauthentication tools which also leverage AI to help and detect counterfeit sneakers.
            </p>
          </div>
          <div className="bg-background-light p-6 rounded-lg shadow-md border border-gray-800">
            <div className="flex items-center justify-center h-16 w-16 rounded-full bg-accent text-white mb-4 mx-auto">
              <FiCheck className="h-8 w-8" />
            </div>
            <h3 className="text-xl font-semibold text-center mb-3 text-white">Detailed Inspection</h3>
            <p className="text-gray-400 text-center">
              We check all aspects of each product including materials, stitching, labels, and packaging to ensure legitimacy.
            </p>
          </div>
          
          <div className="bg-background-light p-6 rounded-lg shadow-md border border-gray-800">
            <div className="flex items-center justify-center h-16 w-16 rounded-full bg-accent text-white mb-4 mx-auto">
              <FiShield className="h-8 w-8" />
            </div>
            <h3 className="text-xl font-semibold text-center mb-3 text-white">Money-Back Guarantee</h3>
            <p className="text-gray-400 text-center">
              In the unlikely event that you receive an inauthentic product, we offer a 100% money-back guarantee.
            </p>
          </div>
        </div>
        
        <div className="mt-12 text-center">
          <p className="font-medium text-lg text-gray-300">
            Shop with confidence knowing that every purchase is backed by our authenticity guarantee.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Authenticity; 